import { cn } from "@/lib/utils";

/**
 * Inline source-attribution chip for an LLM section. Shown when the
 * section's ``facts_used`` contains keys stamped as ``ifc`` in the
 * fact sheet's ``_sources`` map. Mirrors the Ring 2B ``.source-chip``
 * styling so the cutover is visually invisible.
 */
export function SourceChip({
  factKeys,
  className,
}: {
  factKeys: string[];
  className?: string;
}) {
  if (!factKeys.length) return null;
  return (
    <div
      className={cn(
        "mx-4 mt-1.5 inline-flex max-w-[calc(100%-2rem)] items-center gap-1 rounded border border-ind-200 bg-ind-50 px-1.5 py-0.5 text-[0.7rem] text-ind-700",
        className,
      )}
    >
      <span className="font-semibold opacity-70">Izvori (IFC):</span>
      <span className="font-mono text-[0.68rem]">{factKeys.join(", ")}</span>
    </div>
  );
}
